import React from 'react';

import  Avidreader2024  from 'views/Avidreader2024';
const DesktopAppPage = () => {
  return <Avidreader2024 />;
};

export default DesktopAppPage;
